import React, { useEffect } from 'react';
import { useMetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { AuthorSection } from './components/AuthorSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { ClosingSection } from './components/ClosingSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  useMetaPixel();
  useEffect(() => {
    document.title = 'Paz Hormonal';
  }, []);
  return <div className="min-h-screen font-sans bg-brand-cream text-brand-charcoal selection:bg-brand-green/20 selection:text-brand-green" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <HookSection data-id="element-3" />
        <AgitationSection data-id="element-4" />
        <RevelationSection data-id="element-5" />
        <AuthorSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <OfferSection data-id="element-8" />
        <ClosingSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
      </main>
      <footer className="bg-brand-charcoal text-white/50 text-center py-6 text-sm border-t border-white/10" data-id="element-13">
        <p data-id="element-14">
          © {new Date().getFullYear()} Paz Hormonal +40. Todos los derechos
          reservados.
        </p>
      </footer>
      <SalesPopup data-id="element-15" />
    </div>;
}